import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { FaFilter, FaTimes } from "react-icons/fa";

const FunnelFilter = ({ options, selectedOption, onFilterChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const toggleOpen = (event) => {
    event.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleFilterChange = (option) => {
    onFilterChange(option);
    setIsOpen(false);
  };

  const clearFilter = (event) => {
    event.stopPropagation();
    onFilterChange("All"); // Clear filter by resetting to "All"
  };

  useEffect(() => {
    const element = document.querySelector('.funnel-dropdown');
    const rect = ref.current.getBoundingClientRect();

    if (element && rect) {
      element.style.top = `${rect.bottom + window.scrollY}px`;
      element.style.left = `${rect.left}px`;
    }
  }, [isOpen]);

  const dropdown = (
    <div className="funnel-dropdown">
      {options.map((option) => (
        <div
          key={option}
          onClick={(e) => {
            e.stopPropagation();
            handleFilterChange(option);
          }}
          className={`${option === selectedOption ? "selected" : ""}`}
        >
          {option}
        </div>
      ))}
    </div>
  );

  return (
    <div
      ref={ref}
      className="filter-container"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        onClick={toggleOpen}
        className={`filter-button ${selectedOption !== "All" ? "active" : ""}`}
      >
        <FaFilter
          size={18}
          className={`filter-icon ${selectedOption !== "All" ? "active" : ""}`}
        />
        {selectedOption !== "All" && (
          <FaTimes
            size={14}
            className="clear-icon"
            onClick={clearFilter}
            title="Clear Filter"
          />
        )}
      </button>
      {isOpen && createPortal(dropdown, document.body)}
    </div>
  );
};

export default FunnelFilter;